import { useContext } from 'react';
import { AccordionContext } from 'site-modules/shared/components/inventory/accordion/accordion-context';

export const useAccordion = () => {
  const { onToggleItem, openedItems } = useContext(AccordionContext);

  return { onToggleItem, openedItems };
};
